import { fromJS } from 'immutable'

export const StatisticsTutorialVideos = fromJS([
  {
    id: 'statistics',
    title: 'Reporting & Visualizations',
    len: '',
    autoplay: false,
    code: '501928393',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'rb',
    title: 'Radio buttons',
    len: '2:08',
    autoplay: true,
    code: '497745597',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'cb',
    title: 'Checkboxes',
    leh: '3:35',
    autoplay: true,
    code: '497746003',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'oe',
    title: 'Open Ended',
    leh: '4:40',
    autoplay: true,
    code: '501000654',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'oex',
    title: 'Forms',
    leh: '5:47',
    autoplay: true,
    code: '497753282',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'it',
    title: 'Instruction Text',
    leh: '1:39',
    autoplay: true,
    code: '497746417',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'im',
    title: 'Image',
    leh: '2:22',
    autoplay: true,
    code: '497756299',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'vo',
    title: 'Video',
    leh: '2:08',
    autoplay: true,
    code: '499691920',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'mx',
    title: 'Sliders',
    leh: '',
    autoplay: true,
    code: '500572908',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'progressive',
    title: 'Progressive Matrix',
    leh: '',
    autoplay: true,
    code: '497755126',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'sr',
    title: 'Star rating / smileys',
    leh: '',
    autoplay: true,
    code: '497754813',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'ro',
    title: 'Reorder',
    leh: '',
    autoplay: true,
    code: '500902740',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'aro',
    title: 'Side-by-Side comparison',
    leh: '',
    autoplay: true,
    code: '497754040',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'distribute',
    title: 'Distribute',
    leh: '',
    autoplay: true,
    code: '497753696',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'psc',
    title: 'Polarity Scale',
    leh: '',
    autoplay: true,
    code: '497752903',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'cx',
    title: 'Combobox & Cascade',
    leh: '',
    autoplay: true,
    code: '497754473',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'quadrant',
    title: 'Quadrant',
    leh: '',
    autoplay: true,
    code: '-PVd4aP0xCU',
    url: 'https://www.youtube.com/embed/',
    rel: '?rel=0&amp;showinfo=0&amp;enablejsapi=1&amp;start=${startTime}&amp;vq=hd720'
  },
  {
    id: 'topography',
    title: 'Competitive Topography',
    leh: '',
    autoplay: true,
    code: 'DihLlRhJpwo',
    url: 'https://www.youtube.com/embed/',
    rel: '?rel=0&amp;showinfo=0&amp;enablejsapi=1&amp;start=${startTime}&amp;vq=hd720'
  },
  {
    id: 'md',
    title: 'Advanced MaxDiff',
    leh: '',
    autoplay: true,
    code: 'a4uQc5bgseY',
    url: 'https://www.youtube.com/embed/',
    rel: '?rel=0&amp;showinfo=0&amp;enablejsapi=1&amp;start=${startTime}&amp;vq=hd720'
  },
  {
    id: 'cjc',
    title: 'How to conduct Choice Based Conjoint test like a pro',
    len: '',
    autoplay: false,
    code: 'p1tnWV7Fdq8',
    url: 'https://www.youtube.com/embed/',
    rel: '?rel=0&amp;showinfo=0&amp;enablejsapi=1&amp;start=${startTime}&amp;vq=hd720'
  },
  {
    id: 'vk',
    title: 'Price Optimization Model',
    len: '',
    autoplay: true,
    code: '802139486',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'ir',
    title: 'Image Response',
    leh: '',
    autoplay: true,
    code: '497755863',
    url: 'https://player.vimeo.com/video/'
  },
  {
    id: 'va',
    title: 'Video Response',
    leh: '',
    autoplay: true,
    code: '497755442',
    url: 'https://player.vimeo.com/video/'
  }
])

export const getTutorialVideoById = id => StatisticsTutorialVideos.filter(item => item.get('id') == id)
